webpackJsonp([16,14],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(513);
	module.exports = __webpack_require__(502);


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var apiUrl = exports.apiUrl = ("https://api.heltopplagt.no/api");
	var version = exports.version = ("1.6.2");
	var imageFolderPath = exports.imageFolderPath = "https://heltopplagt.blob.core.windows.net/images/";
	var MVA_RATE = exports.MVA_RATE = 0.25;
	var DELIVERY_COST = exports.DELIVERY_COST = 99;
	var CUTOFF_HOUR = exports.CUTOFF_HOUR = "13";
	var CUTOFF_HOUR_CATERING = exports.CUTOFF_HOUR_CATERING = "14";
	
	var MODULE_CONTRACTS = exports.MODULE_CONTRACTS = "nettmeny";
	var MODULE_CATERING = exports.MODULE_CATERING = "catering";
	
	var CATERING_NEXTORDERDAY = exports.CATERING_NEXTORDERDAY = 1;

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(127);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(5);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _state = __webpack_require__(512);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(510);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(507);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _modules = __webpack_require__(509);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _plugins = __webpack_require__(511);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _getters = __webpack_require__(508);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: _state2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default,
	  modules: _modules2.default,
	  plugins: _plugins2.default,
	  getters: getters,
	  strict: ("production") !== 'production'
	});

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAIN_SET_MESSAGE = exports.MAIN_SET_MESSAGE = 'MAIN_SET_MESSAGE';
	var MAIN_SET_FETCHING = exports.MAIN_SET_FETCHING = 'MAIN_SET_FETCHING';
	
	var CATEGORIES_SET_DATA = exports.CATEGORIES_SET_DATA = 'CATEGORIES_SET_DATA';
	var PRODUCTS_SET_DATA = exports.PRODUCTS_SET_DATA = 'PRODUCTS_SET_DATA';
	
	var CONTRACTS_SET = exports.CONTRACTS_SET = 'CONTRACTS_SET';
	var CONTRACT_ACTIVE = exports.CONTRACT_ACTIVE = 'CONTRACT_ACTIVE';
	var CONTRACTS_TOGGLE_LINE = exports.CONTRACTS_TOGGLE_LINE = 'CONTRACTS_TOGGLE_LINE';
	var MENU_REMOVE_ARTICLE = exports.MENU_REMOVE_ARTICLE = 'MENU_REMOVE_ARTICLE';
	
	var SET_INTERMEDIATE_GROUP = exports.SET_INTERMEDIATE_GROUP = 'SET_INTERMEDIATE_GROUP';
	var SET_ARTICLE_QUANTITY = exports.SET_ARTICLE_QUANTITY = 'SET_ARTICLE_QUANTITY';
	var SET_ARTICLE_INTERVAL = exports.SET_ARTICLE_INTERVAL = 'SET_ARTICLE_INTERVAL';
	
	var MENU_ADD_TO_CART = exports.MENU_ADD_TO_CART = 'MENU_ADD_TO_CART';
	
	var SINGLE_ADD_TO_CART = exports.SINGLE_ADD_TO_CART = 'SINGLE_ADD_TO_CART';
	var SINGLE_REMOVE_FROM_CART = exports.SINGLE_REMOVE_FROM_CART = 'SINGLE_REMOVE_FROM_CART';
	var SINGLE_ARTICLE_QUANTITY = exports.SINGLE_ARTICLE_QUANTITY = 'SINGLE_ARTICLE_QUANTITY';
	var SINGLE_EMPTY_CART = exports.SINGLE_EMPTY_CART = 'SINGLE_EMPTY_CART';
	
	var SINGLE_ARTICLE_PRICE = exports.SINGLE_ARTICLE_PRICE = 'SINGLE_ARTICLE_PRICE';
	var SINGLE_REPLACE_CART = exports.SINGLE_REPLACE_CART = 'SINGLE_REPLACE_CART';

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getData = undefined;
	
	var _lodash = __webpack_require__(67);
	
	var getData = exports.getData = function getData(obj) {
	  return (0, _lodash.get)(obj, 'data');
	};

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(515);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.localStorageSetItem = localStorageSetItem;
	exports.localStorageGetItem = localStorageGetItem;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function localStorageSetItem(label, obj) {
	  window.localStorage.setItem(label, (0, _stringify2.default)(obj));
	}
	
	function localStorageGetItem(label) {
	  var string = window.localStorage.getItem(label);
	  return JSON.parse(string);
	}

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_TOKEN = exports.SET_TOKEN = 'Auth//SET_TOKEN';
	var SET_USER = exports.SET_USER = 'Auth//SET_USER';

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(499);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});
	
	var _routes = __webpack_require__(496);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.http = undefined;
	exports.setToken = setToken;
	exports.default = install;
	
	var _axios = __webpack_require__(416);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _interceptors = __webpack_require__(504);
	
	var _interceptors2 = _interopRequireDefault(_interceptors);
	
	var _config = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var http = exports.http = _axios2.default.create({
	  baseURL: _config.apiUrl
	});
	
	function setToken(token) {
	  http.defaults.headers.common.Authorization = 'Bearer ' + token;
	}
	
	function install(Vue, _ref) {
	  var store = _ref.store,
	      router = _ref.router;
	
	  (0, _interceptors2.default)(http, store, router);
	
	  Object.defineProperty(Vue.prototype, '$http', {
	    get: function get() {
	      return http;
	    }
	  });
	}

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(485);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(488);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(492);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(493);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(497);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(498);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  NODE_ENV: '"production"',
	  API_URL: '"https://api.heltopplagt.no/api"',
	
	  VERSION: '"1.6.2"'
	};

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _navbar = __webpack_require__(873);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _alerts = __webpack_require__(870);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _footer = __webpack_require__(872);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'HeltOpplagt',
	  components: {
	    CcNavBar: _navbar2.default,
	    CcAlerts: _alerts2.default,
	    FooterBar: _footer2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['shouldShowNavigation']))
	
	};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _lodash = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['messages']), {
	    hasSuccessMessage: function hasSuccessMessage() {
	      return this.messages.success !== '';
	    },
	    hasErrorMessages: function hasErrorMessages() {
	      return this.messages.error.length > 0;
	    },
	    hasValidationMessages: function hasValidationMessages() {
	      return !(0, _lodash.isEmpty)(this.messages.validation);
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setMessage']), {
	    dismiss: function dismiss(type) {
	      var obj = void 0;
	      if (type === 'error') {
	        obj = { type: type, message: [] };
	      } else if (type === 'validation') {
	        obj = { type: type, message: {} };
	      } else {
	        obj = { type: type, message: '' };
	      }
	      this.setMessage(obj);
	    }
	  })
	};

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['fetching']))
	};

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _prodEnv = __webpack_require__(434);
	
	exports.default = {
	  name: 'footer',
	  data: function data() {
	    return {
	      version: _.trim(_prodEnv.VERSION, '"')
	    };
	  },
	
	  computed: {
	    thisYear: function thisYear() {
	      var dt = new Date();
	      return dt.getFullYear();
	    }
	  }
	};

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _config = __webpack_require__(18);
	
	var _spinner = __webpack_require__(871);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CcSpinner: _spinner2.default
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser', 'isLogged', 'hasModuleContracts', 'hasModuleCatering']), {
	    version: function version() {
	      return _config.version;
	    },
	    isAdmin: function isAdmin() {
	      return this.currentUser.isadmin === '1';
	    }
	  }),
	
	  watch: {
	    isLogged: function isLogged(value) {
	      if (value === false) {
	        this.$router.push({ name: 'auth.signin' });
	      }
	    }
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['logout']))
	};

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(482);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(483);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(98);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminDashboard = function AdminDashboard(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(842));
	  });
	};
	var Calendar = function Calendar(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(840));
	  });
	};
	
	var requiresAdmin = function requiresAdmin(to, from, next) {
	  var auth = _store2.default.state.Auth;
	  if (auth.user && auth.user.isadmin === '1') next();else next({ name: 'dashboard.index' });
	};
	
	var meta = {
	  requiresAuth: true
	};
	
	exports.default = [{
	  name: 'admin',
	  path: '/admin',
	  component: AdminDashboard,
	  meta: meta,
	  beforeEnter: requiresAdmin,
	  children: [{
	    name: 'admin.calendar',
	    path: '/admin/calendar',
	    component: Calendar,
	    meta: meta
	  }]
	}];

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

	"use strict";

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Main = exports.Main = function Main(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(846));
	  });
	};
	var Signin = exports.Signin = function Signin(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(845));
	  });
	};
	var ForgotPassword = exports.ForgotPassword = function ForgotPassword(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(843));
	  });
	};
	var ResetPassword = exports.ResetPassword = function ResetPassword(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(844));
	  });
	};

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(484);
	
	var children = [{
	  name: 'auth.signin',
	  path: 'signin',
	  component: _components.Signin,
	  meta: { requiresAuth: false }
	}, {
	  name: 'auth.singup',
	  path: 'singup',
	  component: _components.Singup,
	  meta: { requiresAuth: false }
	}, {
	  name: 'auth.forgotpassword',
	  path: 'forgotpassword',
	  component: _components.ForgotPassword,
	  meta: { requiresAuth: false }
	}, {
	  name: 'auth.reset',
	  path: 'reset/:token',
	  props: true,
	  component: _components.ResetPassword,
	  meta: { requiresAuth: false }
	}];
	
	exports.default = [{
	  children: children,
	  name: 'auth',
	  path: '/auth',
	  component: _components.Main,
	  redirect: { name: 'auth.signin' },
	  meta: { requiresAuth: false }
	}];

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setToken = exports.setUser = exports.resetPassword = exports.resetPasswordEmail = exports.logout = exports.attemptLogin = undefined;
	
	var _promise = __webpack_require__(70);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _http = __webpack_require__(161);
	
	var _lodash = __webpack_require__(67);
	
	var _get = __webpack_require__(131);
	
	var _mutationsTypes = __webpack_require__(159);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var attemptLogin = exports.attemptLogin = function attemptLogin(_ref, _ref2) {
	  var dispatch = _ref.dispatch;
	  var email = _ref2.email,
	      password = _ref2.password,
	      remember = _ref2.remember;
	  return _http.http.post('/auth/token/issue', { email: email, password: password, remember: remember }).then(_get.getData).then(function (_ref3) {
	    var token = _ref3.token,
	        user = _ref3.user;
	
	    dispatch('setUser', user);
	    dispatch('setToken', token);
	
	    return user;
	  });
	};
	
	var logout = exports.logout = function logout(_ref4) {
	  var dispatch = _ref4.dispatch;
	
	  _http.http.post('/auth/token/revoke');
	
	  return _promise2.default.all([dispatch('setToken', null), dispatch('setUser', {})]);
	};
	
	var resetPasswordEmail = exports.resetPasswordEmail = function resetPasswordEmail(_ref5, _ref6) {
	  var dispatch = _ref5.dispatch;
	  var email = _ref6.email;
	
	  _http.http.post('/auth/password/email', { email: email }).then(function (data) {
	    console.log('resetPasswordEmail: ' + data);
	  });
	};
	
	var resetPassword = exports.resetPassword = function resetPassword(_ref7, _ref8) {
	  var dispatch = _ref7.dispatch;
	  var token = _ref8.token,
	      email = _ref8.email,
	      password = _ref8.password,
	      password_confirmation = _ref8.password_confirmation;
	
	  var res = _http.http.post('/auth/password/reset', { token: token, email: email, password: password, password_confirmation: password_confirmation });
	  return res;
	};
	
	var setUser = exports.setUser = function setUser(_ref9, user) {
	  var commit = _ref9.commit;
	
	  commit(TYPES.SET_USER, user);
	
	  _promise2.default.resolve(user);
	};
	
	var setToken = exports.setToken = function setToken(_ref10, payload) {
	  var commit = _ref10.commit;
	
	  var token = (0, _lodash.isEmpty)(payload) ? null : payload.token || payload;
	
	  (0, _http.setToken)(token);
	
	  commit(TYPES.SET_TOKEN, token);
	
	  return _promise2.default.resolve(token);
	};

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasModuleCatering = exports.hasModuleContracts = exports.currentUser = exports.isLogged = undefined;
	
	var _lodash = __webpack_require__(67);
	
	var _config = __webpack_require__(18);
	
	var isLogged = exports.isLogged = function isLogged(_ref) {
	  var token = _ref.token;
	  return !(0, _lodash.isEmpty)(token);
	};
	var currentUser = exports.currentUser = function currentUser(_ref2) {
	  var user = _ref2.user;
	  return user;
	};
	
	var hasModuleContracts = exports.hasModuleContracts = function hasModuleContracts(_ref3) {
	  var user = _ref3.user;
	
	  if (!(0, _lodash.isEmpty)(user)) {
	    return parseInt(user.mod_contracts, 10) || false;
	  }
	};
	
	var hasModuleCatering = exports.hasModuleCatering = function hasModuleCatering(_ref4) {
	  var user = _ref4.user;
	
	  if (!(0, _lodash.isEmpty)(user)) {
	    return parseInt(user.mod_catering, 10) || false;
	  }
	};

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(491);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(489);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _plugin = __webpack_require__(490);
	
	var _plugin2 = _interopRequireDefault(_plugin);
	
	var _actions = __webpack_require__(486);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(487);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = { state: _state2.default, mutations: _mutations2.default, actions: actions, getters: getters };
	
	exports.default = { module: _module, plugin: _plugin2.default };

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TYPES$SET_TOKEN$TYPE;
	
	var _mutationsTypes = __webpack_require__(159);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_TYPES$SET_TOKEN$TYPE = {}, (0, _defineProperty3.default)(_TYPES$SET_TOKEN$TYPE, TYPES.SET_TOKEN, function (state, value) {
	  state.token = value;
	}), (0, _defineProperty3.default)(_TYPES$SET_TOKEN$TYPE, TYPES.SET_USER, function (state, value) {
	  state.user = value;
	}), _TYPES$SET_TOKEN$TYPE);

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _local = __webpack_require__(132);
	
	var _mutationsTypes = __webpack_require__(159);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var subscribe = function subscribe(store) {
	  store.subscribe(function (mutation, _ref) {
	    var Auth = _ref.Auth;
	
	    if (TYPES.SET_USER === mutation.type) {
	      (0, _local.localStorageSetItem)('user', { user: Auth.user });
	    }
	
	    if (TYPES.SET_TOKEN === mutation.type) {
	      (0, _local.localStorageSetItem)('token', { token: Auth.token });
	    }
	  });
	};
	
	exports.default = function (store) {
	  subscribe(store);
	};

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  user: {},
	  token: null
	};

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(98);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nettmeny = function Nettmeny(resolve) {
	  __webpack_require__.e/* nsure */(7, function () {
	    resolve(__webpack_require__(409));
	  });
	};
	
	var Contract = function Contract(resolve) {
	  __webpack_require__.e/* nsure */(3, function () {
	    resolve(__webpack_require__(404));
	  });
	};
	
	var ContractsList = function ContractsList(resolve) {
	  __webpack_require__.e/* nsure */(9, function () {
	    resolve(__webpack_require__(405));
	  });
	};
	
	var NewMenu = function NewMenu(resolve) {
	  __webpack_require__.e/* nsure */(13, function () {
	    resolve(__webpack_require__(408));
	  });
	};
	
	var ArticlesAdd = function ArticlesAdd(resolve) {
	  __webpack_require__.e/* nsure */(4, function () {
	    resolve(__webpack_require__(403));
	  });
	};
	
	var Delivery = function Delivery(resolve) {
	  __webpack_require__.e/* nsure */(12, function () {
	    resolve(__webpack_require__(407));
	  });
	};
	
	var meta = {
	  requiresAuth: true
	};
	
	var beforeEnter = function beforeEnter(to, from, next) {
	  if (!_store2.default.getters.hasModuleContracts) {
	    next({ path: '/' });
	  }
	  next();
	};
	
	exports.default = [{
	  name: 'menus',
	  path: '/menus',
	  component: Nettmeny,
	  meta: meta,
	  beforeEnter: beforeEnter,
	  children: [{
	    name: 'contractlist',
	    path: 'contractlist',
	    component: ContractsList,
	    meta: meta
	  }, {
	    name: 'contract',
	    path: 'contract/:contractNo',
	    component: Contract,
	    props: true,
	    meta: meta
	  }, {
	    name: 'articles.add',
	    path: 'articles',
	    component: ArticlesAdd,
	    meta: meta
	  }, {
	    name: 'newmenu',
	    path: 'newmenu',
	    component: NewMenu,
	    meta: meta
	  }, {
	    name: 'delivery.index',
	    path: 'delivery',
	    component: Delivery,
	    meta: meta
	  }]
	}];

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(130);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  contracts: {},
	  markedItems: []
	};
	
	var findArticleLineNo = function findArticleLineNo(day, lineno) {
	  var menu = [];
	
	  if (day === 'Monday') {
	    menu = Array.isArray(state.contracts.menuMonday.Article) ? state.contracts.menuMonday.Article : [state.contracts.menuMonday.Article];
	  }
	  if (day === 'Tuesday') {
	    menu = Array.isArray(state.contracts.menuTuesday.Article) ? state.contracts.menuTuesday.Article : [state.contracts.menuTuesday.Article];
	  }
	  if (day === 'Wednesday') {
	    menu = Array.isArray(state.contracts.menuWednesday.Article) ? state.contracts.menuWednesday.Article : [state.contracts.menuWednesday.Article];
	  }
	  if (day === 'Thursday') {
	    menu = Array.isArray(state.contracts.menuThursday.Article) ? state.contracts.menuThursday.Article : [state.contracts.menuThursday.Article];
	  }
	  if (day === 'Friday') {
	    menu = Array.isArray(state.contracts.menuFriday.Article) ? state.contracts.menuFriday.Article : [state.contracts.menuFriday.Article];
	  }
	
	  var foundArticle = menu.find(function (article) {
	    return article.LineNo == lineno;
	  });
	  return foundArticle;
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, TYPES.CONTRACTS_SET, function (st, obj) {
	  st.contracts = obj;
	}), (0, _defineProperty3.default)(_mutations, TYPES.CONTRACT_ACTIVE, function (st, id) {
	  st.contract = id;
	}), (0, _defineProperty3.default)(_mutations, TYPES.SET_ARTICLE_INTERVAL, function (st, obj) {
	  obj.art.Interval = obj.interval;
	  obj.art.Dato = obj.date;
	}), (0, _defineProperty3.default)(_mutations, TYPES.SET_ARTICLE_QUANTITY, function (st, obj) {
	  obj.article.Quantity = obj.qty;
	}), (0, _defineProperty3.default)(_mutations, TYPES.MENU_REMOVE_ARTICLE, function (st, obj) {
	  var index = '';
	
	  switch (obj.day) {
	    case 'Monday':
	      if (Array.isArray(st.contracts.menuMonday.Article)) {
	        index = st.contracts.menuMonday.Article.indexOf(obj.article);
	        st.contracts.menuMonday.Article.splice(index, 1);
	      } else {
	        st.contracts.menuMonday.Article = [];
	      }
	      break;
	    case 'Tuesday':
	      if (Array.isArray(st.contracts.menuTuesday.Article)) {
	        index = st.contracts.menuTuesday.Article.indexOf(obj.article);
	        st.contracts.menuTuesday.Article.splice(index, 1);
	      } else {
	        st.contracts.menuTuesday.Article = [];
	      }
	      break;
	    case 'Wednesday':
	      if (Array.isArray(st.contracts.menuWednesday.Article)) {
	        index = st.contracts.menuWednesday.Article.indexOf(obj.article);
	        st.contracts.menuWednesday.Article.splice(index, 1);
	      } else {
	        st.contracts.menuWednesday.Article = [];
	      }
	      break;
	    case 'Thursday':
	      if (Array.isArray(st.contracts.menuThursday.Article)) {
	        index = st.contracts.menuThursday.Article.indexOf(obj.article);
	        st.contracts.menuThursday.Article.splice(index, 1);
	      } else {
	        st.contracts.menuThursday.Article = [];
	      }
	      break;
	    case 'Friday':
	      if (Array.isArray(st.contracts.menuFriday.Article)) {
	        index = st.contracts.menuFriday.Article.indexOf(obj.article);
	        st.contracts.menuFriday.Article.splice(index, 1);
	      } else {
	        st.contracts.menuFriday.Article = [];
	      }
	      break;
	    default:
	  }
	}), (0, _defineProperty3.default)(_mutations, TYPES.MENU_ADD_TO_CART, function (st, obj) {
	  st.cart.push([obj]);
	}), (0, _defineProperty3.default)(_mutations, TYPES.CONTRACTS_TOGGLE_LINE, function (st, obj) {}), _mutations);
	
	var actions = {
	  toggleMarkedArticles: function toggleMarkedArticles(_ref, obj) {
	    var commit = _ref.commit;
	  },
	  setContracts: function setContracts(_ref2, obj) {
	    var commit = _ref2.commit;
	
	    commit(TYPES.CONTRACTS_SET, obj);
	  },
	  setActiveContract: function setActiveContract(_ref3, id) {
	    var commit = _ref3.commit;
	
	    commit(TYPES.CONTRACT_ACTIVE, id);
	  },
	  articleChangeQuantity: function articleChangeQuantity(_ref4, item) {
	    var commit = _ref4.commit;
	
	    var art = findArticleLineNo(item.day, item.article.LineNo);
	    var quantity = parseInt(item.qty, 10);
	
	    if (quantity < 0) {
	      commit(TYPES.SET_ARTICLE_QUANTITY, {
	        article: art,
	        qty: 0
	      });
	    } else {
	      commit(TYPES.SET_ARTICLE_QUANTITY, {
	        article: art,
	        qty: quantity
	      });
	    }
	  },
	  articleChangeInterval: function articleChangeInterval(_ref5, obj) {
	    var commit = _ref5.commit;
	
	    var art = findArticleLineNo(obj.day, obj.lineno);
	    commit(TYPES.SET_ARTICLE_INTERVAL, {
	      art: art,
	      interval: obj.interval,
	      date: obj.date
	    });
	  },
	  deleteFromMenu: function deleteFromMenu(_ref6, obj) {
	    var commit = _ref6.commit;
	
	    commit(TYPES.MENU_REMOVE_ARTICLE, obj);
	  },
	  addToCart: function addToCart(_ref7, obj) {
	    var commit = _ref7.commit;
	
	    commit(TYPES.MENU_ADD_TO_CART, obj);
	  }
	};
	
	var getters = {
	  getContractNo: function getContractNo(state) {
	    if (state.contracts.contract) {
	      return state.contracts.contract.ContractNo;
	    }
	    return 0;
	  },
	  getMonday: function getMonday(state) {
	    return state.contracts.menuMonday;
	  },
	  getTuesday: function getTuesday(state) {
	    return state.contracts.menuTuesday;
	  },
	  getWednesday: function getWednesday(state) {
	    return state.contracts.menuWednesday;
	  },
	  getThursday: function getThursday(state) {
	    return state.contracts.menuThursday;
	  },
	  getFriday: function getFriday(state) {
	    return state.contracts.menuFriday;
	  },
	  getContract: function getContract(state) {
	    return state.contracts.contract;
	  },
	  isCateringCustomer: function isCateringCustomer(state) {
	    return Boolean(state.contracts.contract.CateringCustomer);
	  }
	};
	
	var _module = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};
	exports.default = { module: _module };

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(495);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var Dashboard = function Dashboard(r) {
	  return __webpack_require__.e/* nsure */(11, function () {
	    return r(__webpack_require__(858));
	  });
	};
	
	var meta = {
	  requiresAuth: true
	};
	
	exports.default = [{
	  name: 'dashboard.index',
	  path: '/',
	  component: Dashboard,
	  meta: meta
	}, {
	  name: 'catchall',
	  path: '*',
	  component: Dashboard,
	  meta: meta
	}];

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _dashboard = __webpack_require__(494);
	
	var _contracts = __webpack_require__(214);
	
	var _singleorder = __webpack_require__(216);
	
	var _auth = __webpack_require__(213);
	
	var _admin = __webpack_require__(481);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [].concat((0, _toConsumableArray3.default)(_auth.routes), (0, _toConsumableArray3.default)(_singleorder.routes), (0, _toConsumableArray3.default)(_contracts.routes), (0, _toConsumableArray3.default)(_dashboard.routes), (0, _toConsumableArray3.default)(_admin.routes));

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(98);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = function Main(resolve) {
	  __webpack_require__.e/* nsure */(2, function () {
	    resolve(__webpack_require__(413));
	  });
	};
	
	var Cart = function Cart(resolve) {
	  __webpack_require__.e/* nsure */(6, function () {
	    resolve(__webpack_require__(410));
	  });
	};
	
	var Order = function Order(resolve) {
	  __webpack_require__.e/* nsure */(5, function () {
	    resolve(__webpack_require__(411));
	  });
	};
	
	var OrderConfirmation = function OrderConfirmation(resolve) {
	  __webpack_require__.e/* nsure */(8, function () {
	    resolve(__webpack_require__(412));
	  });
	};
	
	var Product = function Product(resolve) {
	  __webpack_require__.e/* nsure */(10, function () {
	    resolve(__webpack_require__(414));
	  });
	};
	
	var meta = {
	  requiresAuth: true
	};
	
	var beforeEnter = function beforeEnter(to, from, next) {
	  if (!_store2.default.getters.hasModuleCatering) {
	    next({ path: '/' });
	  }
	  next();
	};
	
	exports.default = [{
	  name: 'catering',
	  path: '/catering',
	  component: Main,
	  meta: meta,
	  beforeEnter: beforeEnter
	}, {
	  name: 'catering.cart',
	  path: '/catering/cart',
	  component: Cart,
	  meta: meta,
	  beforeEnter: beforeEnter
	}, {
	  name: 'catering.order',
	  path: '/catering/order',
	  component: Order,
	  meta: meta,
	  beforeEnter: beforeEnter
	}, {
	  name: 'catering.product',
	  path: '/catering/product/:product_id',
	  props: true,
	  component: Product,
	  meta: meta,
	  beforeEnter: beforeEnter
	}, {
	  name: 'catering.orderconfirmation',
	  path: '/catering/orderconfirmation',
	  component: OrderConfirmation,
	  meta: meta,
	  beforeEnter: beforeEnter
	}];

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(130);
	
	var TYPES = _interopRequireWildcard(_types);
	
	var _local = __webpack_require__(132);
	
	var _http = __webpack_require__(161);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  intermediateGroup: '',
	  cart: []
	};
	
	var hasLocalCart = function hasLocalCart() {
	  if ((0, _local.localStorageGetItem)('cart')) {
	    if ((0, _local.localStorageGetItem)('cart').length > 0) {
	      return true;
	    } else {
	      return false;
	    }
	  } else {
	    return false;
	  }
	};
	
	var saveToLocalCart = function saveToLocalCart(cart) {
	  (0, _local.localStorageSetItem)('cart', cart);
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, TYPES.SET_INTERMEDIATE_GROUP, function (st, obj) {
	  st.intermediateGroup = obj;
	}), (0, _defineProperty3.default)(_mutations, TYPES.SINGLE_REPLACE_CART, function (st, obj) {
	  var existingArticle = st.cart.find(function (a) {
	    return a.articleNumber === obj.articleNumber;
	  });
	
	  if (existingArticle) {
	    existingArticle.quantity = obj.quantity;
	  } else {
	    st.cart.push(obj);
	  }
	}), (0, _defineProperty3.default)(_mutations, TYPES.SINGLE_ADD_TO_CART, function (st, obj) {
	  var existingArticle = st.cart.find(function (a) {
	    return a.articleNumber === obj.articleNumber;
	  });
	
	  if (existingArticle) {
	    existingArticle.quantity += obj.quantity;
	  } else {
	    st.cart.push(obj);
	  }
	
	  saveToLocalCart(st.cart);
	}), (0, _defineProperty3.default)(_mutations, TYPES.SINGLE_ARTICLE_QUANTITY, function (st, obj) {
	  var existingArticle = st.cart.find(function (a) {
	    return a.articleNumber === obj.articleNumber;
	  });
	
	  if (existingArticle) {
	    existingArticle.quantity = obj.quantity;
	  }
	
	  saveToLocalCart(st.cart);
	}), (0, _defineProperty3.default)(_mutations, TYPES.SINGLE_EMPTY_CART, function (st) {
	  st.cart = [];
	  saveToLocalCart(st.cart);
	}), (0, _defineProperty3.default)(_mutations, TYPES.SINGLE_REMOVE_FROM_CART, function (st, index) {
	  st.cart.splice(index, 1);
	  saveToLocalCart(st.cart);
	}), (0, _defineProperty3.default)(_mutations, TYPES.SINGLE_ARTICLE_PRICE, function (st, obj) {
	  var article = st.cart.find(function (a) {
	    return a.articleNumber === obj.articleNumber;
	  });
	  article.price = obj.price;
	  saveToLocalCart(st.cart);
	}), _mutations);
	
	var getters = {
	  activeGroup: function activeGroup(state) {
	    return state.intermediateGroup;
	  }
	};
	
	var actions = {
	  loadCart: function loadCart(_ref) {
	    var commit = _ref.commit;
	
	    if (hasLocalCart()) {
	      var localCart = (0, _local.localStorageGetItem)('cart');
	
	      localCart.map(function (article) {
	        commit(TYPES.SINGLE_REPLACE_CART, article);
	
	        _http.http.get('/catering/find/' + article.articleNumber).then(function (result) {
	          var updatedPrice = result.data.Article.Price;
	          commit(TYPES.SINGLE_ARTICLE_PRICE, {
	            articleNumber: article.articleNumber,
	            price: updatedPrice
	          });
	        }).catch(function (error) {});
	      });
	    }
	  },
	  setIntermediateGroup: function setIntermediateGroup(_ref2, obj) {
	    var commit = _ref2.commit;
	
	    commit(TYPES.SET_INTERMEDIATE_GROUP, obj);
	  },
	  singleAddToCart: function singleAddToCart(_ref3, obj) {
	    var commit = _ref3.commit;
	
	    commit(TYPES.SINGLE_ADD_TO_CART, obj);
	  },
	  updateQuantity: function updateQuantity(_ref4, obj) {
	    var commit = _ref4.commit;
	
	    commit(TYPES.SINGLE_ARTICLE_QUANTITY, obj);
	  },
	  deleteFromCart: function deleteFromCart(_ref5, obj) {
	    var commit = _ref5.commit;
	
	    var idx = state.cart.indexOf(obj);
	    commit(TYPES.SINGLE_REMOVE_FROM_CART, idx);
	  },
	  emptyCart: function emptyCart(_ref6) {
	    var commit = _ref6.commit;
	
	    commit(TYPES.SINGLE_EMPTY_CART);
	  }
	};
	
	var _module = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};
	
	exports.default = { module: _module };

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(6);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _keys = __webpack_require__(519);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(67);
	
	var _contracts = __webpack_require__(214);
	
	var _singleorder = __webpack_require__(216);
	
	var _auth = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vuex = {
	  Contracts: _contracts.vuex,
	  Singleorder: _singleorder.vuex,
	  Auth: _auth.vuex
	};
	var keys = (0, _keys2.default)(vuex);
	
	var modules = keys.reduce(function (acc, key) {
	  return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, key, vuex[key].module));
	}, {});
	var plugins = keys.reduce(function (acc, key) {
	  return [].concat((0, _toConsumableArray3.default)(acc), [vuex[key].plugin]);
	}, []).filter(_lodash.isFunction);
	exports.default = { modules: modules, plugins: plugins };

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	window.$ = window.jQuery = __webpack_require__(200);
	__webpack_require__(520);
	__webpack_require__(836);
	
	var moment = __webpack_require__(1);
	moment.locale('nb');

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vuexRouterSync = __webpack_require__(923);
	
	var _vue = __webpack_require__(127);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _veeValidate = __webpack_require__(838);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _nb_NO = __webpack_require__(837);
	
	var _nb_NO2 = _interopRequireDefault(_nb_NO);
	
	var _Root = __webpack_require__(839);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _store = __webpack_require__(98);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(506);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _http = __webpack_require__(161);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _eventbus = __webpack_require__(503);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _lodash = __webpack_require__(67);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(501);
	
	_vue2.default.use(_http2.default, { store: _store2.default, router: _router2.default });
	
	_vue2.default.use(_eventbus2.default);
	
	_vue2.default.use(_veeValidate2.default);
	_veeValidate.Validator.localize('nb_NO', _nb_NO2.default);
	
	_vue2.default.filter('priceToLocal', function (price) {
	  return price.replace('.', ',').replace(',00', ',-');
	});
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	new _vue2.default({
	  store: _store2.default,
	  router: _router2.default,
	  el: '#app',
	  render: function render(h) {
	    return h(_Root2.default);
	  }
	});
	
	Object.defineProperty(_vue2.default.prototype, '$_', { value: _lodash2.default });

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperties = __webpack_require__(517);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	exports.default = install;
	
	var _vue = __webpack_require__(127);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bus = new _vue2.default();
	
	function install(Vue) {
	  (0, _defineProperties2.default)(Vue.prototype, {
	    $bus: {
	      get: function get() {
	        return bus;
	      }
	    }
	  });
	}

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(70);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (http, store, router) {
	  http.interceptors.response.use(function (response) {
	    return response;
	  }, function (error) {
	    var response = error.response;
	
	    if ([401, 400].indexOf(response.status) > -1) {
	      router.push({ name: 'auth.signin' });
	    }
	
	    if ((0, _lodash.isArray)(response.data)) {
	      store.dispatch('setMessage', { type: 'error', message: response.data.messages });
	    } else {
	      store.dispatch('setMessage', { type: 'validation', message: response.data });
	    }
	
	    store.dispatch('setFetching', { fetching: false });
	
	    return _promise2.default.reject(error);
	  });
	};

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(98);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _lodash = __webpack_require__(67);
	
	var _local = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var needAuth = function needAuth(auth, token) {
	  return auth !== undefined && auth && (0, _lodash.isEmpty)(token);
	};
	
	var beforeEach = function beforeEach(to, from, next) {
	  _store2.default.dispatch('resetMessages');
	
	  var token = _store2.default.state.Auth.token;
	  var auth = to.meta.requiresAuth;
	
	  if ((0, _lodash.isEmpty)(token)) {
	    var localStoredToken = (0, _local.localStorageGetItem)('token');
	    var localStoredUser = (0, _local.localStorageGetItem)('user');
	
	    if (localStoredToken !== undefined && localStoredToken !== null && localStoredUser !== undefined && localStoredUser !== null) {
	      token = localStoredToken.token;
	      _store2.default.dispatch('setToken', token);
	      _store2.default.dispatch('setUser', localStoredUser.user);
	    }
	  }
	
	  if (!needAuth(auth, token)) {
	    next();
	  }
	
	  if (needAuth(auth, token)) {
	    next({ name: 'auth.signin' });
	  }
	};
	
	exports.default = beforeEach;

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _vue = __webpack_require__(127);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(921);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _beforeEach = __webpack_require__(505);
	
	var _beforeEach2 = _interopRequireDefault(_beforeEach);
	
	var _app = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [].concat((0, _toConsumableArray3.default)(_app.routes));
	
	var router = new _vueRouter2.default({
	  routes: routes,
	  linkActiveClass: 'active',
	  mode: 'history' });
	
	router.beforeEach(_beforeEach2.default);
	
	exports.default = router;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(130);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  setFetching: function setFetching(_ref, obj) {
	    var commit = _ref.commit;
	
	    commit(TYPES.MAIN_SET_FETCHING, obj);
	  },
	  setMessage: function setMessage(_ref2, obj) {
	    var commit = _ref2.commit;
	
	    commit(TYPES.MAIN_SET_MESSAGE, obj);
	  },
	  resetMessages: function resetMessages(_ref3) {
	    var commit = _ref3.commit;
	
	    commit(TYPES.MAIN_SET_MESSAGE, { type: 'success', message: '' });
	    commit(TYPES.MAIN_SET_MESSAGE, { type: 'error', message: [] });
	    commit(TYPES.MAIN_SET_MESSAGE, { type: 'warning', message: '' });
	    commit(TYPES.MAIN_SET_MESSAGE, { type: 'validation', message: {} });
	  }
	};

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isAuthPage = exports.isAuthPage = function isAuthPage(_ref) {
	  var route = _ref.route;
	  return route.path.indexOf('/auth') !== -1;
	};
	
	var shouldShowNavigation = exports.shouldShowNavigation = function shouldShowNavigation(_ref2, getters) {
	  var route = _ref2.route;
	  return route.path ? !getters.isAuthPage : false;
	};

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _app = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _extends3.default)({}, _app.vuex.modules);

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TYPES$MAIN_SET_FETCH;
	
	var _types = __webpack_require__(130);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_TYPES$MAIN_SET_FETCH = {}, (0, _defineProperty3.default)(_TYPES$MAIN_SET_FETCH, TYPES.MAIN_SET_FETCHING, function (state, obj) {
	  state.fetching = obj.fetching;
	}), (0, _defineProperty3.default)(_TYPES$MAIN_SET_FETCH, TYPES.MAIN_SET_MESSAGE, function (state, obj) {
	  state.messages[obj.type] = obj.message;
	}), _TYPES$MAIN_SET_FETCH);

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(133);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _app = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [].concat((0, _toConsumableArray3.default)(_app.vuex.plugins));

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  messages: {
	    success: '',
	    error: [],
	    warning: '',
	    validation: {}
	  },
	  fetching: false
	};

/***/ }),

/***/ 796:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 811:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 813:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 814:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 266,
		"./af.js": 266,
		"./ar": 273,
		"./ar-dz": 267,
		"./ar-dz.js": 267,
		"./ar-kw": 268,
		"./ar-kw.js": 268,
		"./ar-ly": 269,
		"./ar-ly.js": 269,
		"./ar-ma": 270,
		"./ar-ma.js": 270,
		"./ar-sa": 271,
		"./ar-sa.js": 271,
		"./ar-tn": 272,
		"./ar-tn.js": 272,
		"./ar.js": 273,
		"./az": 274,
		"./az.js": 274,
		"./be": 275,
		"./be.js": 275,
		"./bg": 276,
		"./bg.js": 276,
		"./bm": 277,
		"./bm.js": 277,
		"./bn": 279,
		"./bn-bd": 278,
		"./bn-bd.js": 278,
		"./bn.js": 279,
		"./bo": 280,
		"./bo.js": 280,
		"./br": 281,
		"./br.js": 281,
		"./bs": 282,
		"./bs.js": 282,
		"./ca": 283,
		"./ca.js": 283,
		"./cs": 284,
		"./cs.js": 284,
		"./cv": 285,
		"./cv.js": 285,
		"./cy": 286,
		"./cy.js": 286,
		"./da": 287,
		"./da.js": 287,
		"./de": 290,
		"./de-at": 288,
		"./de-at.js": 288,
		"./de-ch": 289,
		"./de-ch.js": 289,
		"./de.js": 290,
		"./dv": 291,
		"./dv.js": 291,
		"./el": 292,
		"./el.js": 292,
		"./en-au": 293,
		"./en-au.js": 293,
		"./en-ca": 294,
		"./en-ca.js": 294,
		"./en-gb": 295,
		"./en-gb.js": 295,
		"./en-ie": 296,
		"./en-ie.js": 296,
		"./en-il": 297,
		"./en-il.js": 297,
		"./en-in": 298,
		"./en-in.js": 298,
		"./en-nz": 299,
		"./en-nz.js": 299,
		"./en-sg": 300,
		"./en-sg.js": 300,
		"./eo": 301,
		"./eo.js": 301,
		"./es": 305,
		"./es-do": 302,
		"./es-do.js": 302,
		"./es-mx": 303,
		"./es-mx.js": 303,
		"./es-us": 304,
		"./es-us.js": 304,
		"./es.js": 305,
		"./et": 306,
		"./et.js": 306,
		"./eu": 307,
		"./eu.js": 307,
		"./fa": 308,
		"./fa.js": 308,
		"./fi": 309,
		"./fi.js": 309,
		"./fil": 310,
		"./fil.js": 310,
		"./fo": 311,
		"./fo.js": 311,
		"./fr": 314,
		"./fr-ca": 312,
		"./fr-ca.js": 312,
		"./fr-ch": 313,
		"./fr-ch.js": 313,
		"./fr.js": 314,
		"./fy": 315,
		"./fy.js": 315,
		"./ga": 316,
		"./ga.js": 316,
		"./gd": 317,
		"./gd.js": 317,
		"./gl": 318,
		"./gl.js": 318,
		"./gom-deva": 319,
		"./gom-deva.js": 319,
		"./gom-latn": 320,
		"./gom-latn.js": 320,
		"./gu": 321,
		"./gu.js": 321,
		"./he": 322,
		"./he.js": 322,
		"./hi": 323,
		"./hi.js": 323,
		"./hr": 324,
		"./hr.js": 324,
		"./hu": 325,
		"./hu.js": 325,
		"./hy-am": 326,
		"./hy-am.js": 326,
		"./id": 327,
		"./id.js": 327,
		"./is": 328,
		"./is.js": 328,
		"./it": 330,
		"./it-ch": 329,
		"./it-ch.js": 329,
		"./it.js": 330,
		"./ja": 331,
		"./ja.js": 331,
		"./jv": 332,
		"./jv.js": 332,
		"./ka": 333,
		"./ka.js": 333,
		"./kk": 334,
		"./kk.js": 334,
		"./km": 335,
		"./km.js": 335,
		"./kn": 336,
		"./kn.js": 336,
		"./ko": 337,
		"./ko.js": 337,
		"./ku": 338,
		"./ku.js": 338,
		"./ky": 339,
		"./ky.js": 339,
		"./lb": 340,
		"./lb.js": 340,
		"./lo": 341,
		"./lo.js": 341,
		"./lt": 342,
		"./lt.js": 342,
		"./lv": 343,
		"./lv.js": 343,
		"./me": 344,
		"./me.js": 344,
		"./mi": 345,
		"./mi.js": 345,
		"./mk": 346,
		"./mk.js": 346,
		"./ml": 347,
		"./ml.js": 347,
		"./mn": 348,
		"./mn.js": 348,
		"./mr": 349,
		"./mr.js": 349,
		"./ms": 351,
		"./ms-my": 350,
		"./ms-my.js": 350,
		"./ms.js": 351,
		"./mt": 352,
		"./mt.js": 352,
		"./my": 353,
		"./my.js": 353,
		"./nb": 354,
		"./nb.js": 354,
		"./ne": 355,
		"./ne.js": 355,
		"./nl": 357,
		"./nl-be": 356,
		"./nl-be.js": 356,
		"./nl.js": 357,
		"./nn": 358,
		"./nn.js": 358,
		"./oc-lnc": 359,
		"./oc-lnc.js": 359,
		"./pa-in": 360,
		"./pa-in.js": 360,
		"./pl": 361,
		"./pl.js": 361,
		"./pt": 363,
		"./pt-br": 362,
		"./pt-br.js": 362,
		"./pt.js": 363,
		"./ro": 364,
		"./ro.js": 364,
		"./ru": 365,
		"./ru.js": 365,
		"./sd": 366,
		"./sd.js": 366,
		"./se": 367,
		"./se.js": 367,
		"./si": 368,
		"./si.js": 368,
		"./sk": 369,
		"./sk.js": 369,
		"./sl": 370,
		"./sl.js": 370,
		"./sq": 371,
		"./sq.js": 371,
		"./sr": 373,
		"./sr-cyrl": 372,
		"./sr-cyrl.js": 372,
		"./sr.js": 373,
		"./ss": 374,
		"./ss.js": 374,
		"./sv": 375,
		"./sv.js": 375,
		"./sw": 376,
		"./sw.js": 376,
		"./ta": 377,
		"./ta.js": 377,
		"./te": 378,
		"./te.js": 378,
		"./tet": 379,
		"./tet.js": 379,
		"./tg": 380,
		"./tg.js": 380,
		"./th": 381,
		"./th.js": 381,
		"./tk": 382,
		"./tk.js": 382,
		"./tl-ph": 383,
		"./tl-ph.js": 383,
		"./tlh": 384,
		"./tlh.js": 384,
		"./tr": 385,
		"./tr.js": 385,
		"./tzl": 386,
		"./tzl.js": 386,
		"./tzm": 388,
		"./tzm-latn": 387,
		"./tzm-latn.js": 387,
		"./tzm.js": 388,
		"./ug-cn": 389,
		"./ug-cn.js": 389,
		"./uk": 390,
		"./uk.js": 390,
		"./ur": 391,
		"./ur.js": 391,
		"./uz": 393,
		"./uz-latn": 392,
		"./uz-latn.js": 392,
		"./uz.js": 393,
		"./vi": 394,
		"./vi.js": 394,
		"./x-pseudo": 395,
		"./x-pseudo.js": 395,
		"./yo": 396,
		"./yo.js": 396,
		"./zh-cn": 397,
		"./zh-cn.js": 397,
		"./zh-hk": 398,
		"./zh-hk.js": 398,
		"./zh-mo": 399,
		"./zh-mo.js": 399,
		"./zh-tw": 400,
		"./zh-tw.js": 400
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 829;


/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(813)
	
	/* script */
	__vue_exports__ = __webpack_require__(435)
	
	/* template */
	var __vue_template__ = __webpack_require__(902)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(811)
	
	/* script */
	__vue_exports__ = __webpack_require__(477)
	
	/* template */
	var __vue_template__ = __webpack_require__(900)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(823)
	
	/* script */
	__vue_exports__ = __webpack_require__(478)
	
	/* template */
	var __vue_template__ = __webpack_require__(915)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d1d67ad4"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(796)
	
	/* script */
	__vue_exports__ = __webpack_require__(479)
	
	/* template */
	var __vue_template__ = __webpack_require__(883)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-23e329c6"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(814)
	
	/* script */
	__vue_exports__ = __webpack_require__(480)
	
	/* template */
	var __vue_template__ = __webpack_require__(905)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ad5648a"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 883:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "footer"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-md-3"
	  }, [_c('ul', [_c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'contractlist'
	      },
	      "exact": ""
	    }
	  }, [_c('a', [_vm._v("Nettmeny")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'catering'
	      },
	      "exact": ""
	    }
	  }, [_c('a', [_vm._v("Catering")])])], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v("\n          " + _vm._s(_vm.thisYear) + " © Helt Opplagt på Jobben.\n          "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Bruker- og salgsbetingelser.")]), _vm._v(" "), _c('span', {
	    staticClass: "app__version pull-right"
	  }, [_vm._v("v" + _vm._s(this.version))])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12 col-md-3"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/HeltOpplagtLogo.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12 col-md-3"
	  }, [_c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('strong', [_vm._v("Support 0800 - 1600")])])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "fa fa-phone",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "tel:02346"
	    }
	  }, [_vm._v("0 23 46")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "mailto:post@heltopplagt.no"
	    }
	  }, [_vm._v("post@heltopplagt.no")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/Heltopplagt",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-2x fa-facebook-official",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://plus.google.com/+HeltopplagtNofruktlunsjogrenluft/",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-2x fa-google-plus-square",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])])
	}]}

/***/ }),

/***/ 900:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasSuccessMessage),
	      expression: "hasSuccessMessage"
	    }],
	    staticClass: "alert alert-success"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.dismiss('success')
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v("\n    " + _vm._s(_vm.messages.success) + "\n  ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasErrorMessages),
	      expression: "hasErrorMessages"
	    }],
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.dismiss('error')
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('ul', _vm._l((_vm.messages.error), function(error) {
	    return _c('li', [_vm._v(_vm._s(error))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasValidationMessages),
	      expression: "hasValidationMessages"
	    }],
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.dismiss('validation')
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('ul', _vm._l((_vm.messages.validation.messages), function(msg) {
	    return _c('li', [_vm._v(_vm._s(msg))])
	  }), 0)])])
	},staticRenderFns: []}

/***/ }),

/***/ 902:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('cc-nav-bar', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.shouldShowNavigation),
	      expression: "shouldShowNavigation"
	    }]
	  }), _vm._v(" "), _c('div', {}, [_c('cc-alerts'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer-bar', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.shouldShowNavigation),
	      expression: "shouldShowNavigation"
	    }]
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 905:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "navbar navbar-default"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "navbar-header"
	  }, [_vm._m(0), _vm._v(" "), _c('a', {
	    staticClass: "navbar-brand",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('ul', {
	    staticClass: "headermenu"
	  }, [_c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'dashboard.index'
	      },
	      "exact": ""
	    }
	  }, [_c('a', [_vm._v("Helt Opplagt")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('cc-spinner')], 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse navbar-collapse",
	    attrs: {
	      "id": "app-navbar-collapse"
	    }
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_vm._v("\n           \n      ")]), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav navbar-right"
	  }, [(_vm.hasModuleContracts) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'contractlist'
	      },
	      "exact": ""
	    }
	  }, [_c('a', [_vm._v("Nettmeny")])]) : _vm._e(), _vm._v(" "), (_vm.hasModuleCatering) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'catering'
	      },
	      "exact": ""
	    }
	  }, [_c('a', [_vm._v("Catering")])]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "dropdown"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.currentUser.name) + " " + _vm._s(_vm.currentUser.customernumber) + " "), _c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [(_vm.isAdmin) ? [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'admin'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Administrasjon\n                ")])], 1)] : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.logout
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Logg ut\n              ")])])], 2)])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "navbar-toggle collapsed",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#app-navbar-collapse"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Vis meny")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('i', {
	    staticClass: "fa fa-phone",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "tel:02346"
	    }
	  }, [_vm._v(" 0 23 46")])])
	}]}

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.fetching),
	      expression: "fetching"
	    }],
	    staticClass: "fa fa-fw fa-lg fa-cog fa-spin"
	  })])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.c2622795618e34517fa2.js